// Généré par maquettes/outils/dc2react.py à partir de la maquette. Ne pas modifier à la main :
// changer maquettes/src puis relancer le script.
import React from 'react';

export default function Canaux({ v }) {
  return (
    <section id="canaux" style={{ borderTop: "1px solid #E3E5E8" }}>
      <div className="m-sec" style={{ maxWidth: "1240px", margin: "0 auto", padding: "96px 24px", display: "flex", flexDirection: "column", gap: "32px" }}>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(440px, 100%), 1fr))", gap: "20px 64px", alignItems: "end" }}>
          <div style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
            <p style={{ margin: "0", fontFamily: "'IBM Plex Mono', ui-monospace, monospace", fontSize: "13px", color: "#5A6068" }}>
              Votre façon de vendre
            </p>
            <h2 style={{ margin: "0", fontSize: "clamp(32px, 3.4vw, 48px)", fontWeight: "800", fontStretch: "80%", lineHeight: "1.04", textWrap: "balance" }}>
              Pas seulement Amazon et Shopify.
            </h2>
          </div>
          <p style={{ margin: "0", fontSize: "18px", lineHeight: "1.55", color: "#30353C" }}>
            L'outil part de la façon dont votre marque fonctionne vraiment : ce que vous fabriquez, la façon dont vous déclinez vos produits, et tous les endroits où ils se vendent.
          </p>
        </div>
        <div className="canaux-grid" style={{ display: "grid", gridTemplateColumns: "repeat(4, minmax(0, 1fr))", gap: "1px", background: "#E3E5E8", border: "1px solid #E3E5E8" }}>
          <div style={{ padding: "22px", background: "#FFFFFF", display: "flex", flexDirection: "column", gap: "8px" }}>
            <p style={{ margin: "0", fontFamily: "'IBM Plex Mono', ui-monospace, monospace", fontSize: "12px", color: "#5A6068" }}>
              Fabrication
            </p>
            <p style={{ margin: "0", fontWeight: "700", fontSize: "18px" }}>
              Vous fabriquez vous-même
            </p>
            <p style={{ margin: "0", fontSize: "15px", color: "#4A5059" }}>
              Atelier, usine, labo ou façonnier : quoi lancer en production, quand et en quelle quantité, avec les matières et les composants à commander à temps.
            </p>
          </div>
          <div style={{ padding: "22px", background: "#FFFFFF", display: "flex", flexDirection: "column", gap: "8px" }}>
            <p style={{ margin: "0", fontFamily: "'IBM Plex Mono', ui-monospace, monospace", fontSize: "12px", color: "#5A6068" }}>
              Tailles et saison
            </p>
            <p style={{ margin: "0", fontWeight: "700", fontSize: "18px" }}>
              Vous vendez par taille et par collection
            </p>
            <p style={{ margin: "0", fontSize: "15px", color: "#4A5059" }}>
              Combien de chaque taille et de chaque coloris commander pour la saison, à partir des ventes passées et des précommandes de vos revendeurs. Et ce qui dort en fin de saison.
            </p>
          </div>
          <div style={{ padding: "22px", background: "#FFFFFF", display: "flex", flexDirection: "column", gap: "8px" }}>
            <p style={{ margin: "0", fontFamily: "'IBM Plex Mono', ui-monospace, monospace", fontSize: "12px", color: "#5A6068" }}>
              Boutiques et revendeurs
            </p>
            <p style={{ margin: "0", fontWeight: "700", fontSize: "18px" }}>
              Vos ventes passent par des magasins
            </p>
            <p style={{ margin: "0", fontSize: "15px", color: "#4A5059" }}>
              Le stock de chaque boutique, de l'entrepôt et du site au même endroit, et le réassort de vos magasins et de vos revendeurs pendant la saison.
            </p>
          </div>
          <div style={{ padding: "22px", background: "#FFFFFF", display: "flex", flexDirection: "column", gap: "8px" }}>
            <p style={{ margin: "0", fontFamily: "'IBM Plex Mono', ui-monospace, monospace", fontSize: "12px", color: "#5A6068" }}>
              Enseignes et pharmacies
            </p>
            <p style={{ margin: "0", fontWeight: "700", fontSize: "18px" }}>
              Vous vendez en grande distribution ou en pharmacie
            </p>
            <p style={{ margin: "0", fontSize: "15px", color: "#4A5059" }}>
              Les commandes des enseignes et des centrales, les promotions, et pour l'alimentaire et les compléments, les lots et les dates de péremption.
            </p>
          </div>
        </div>
        <p style={{ margin: "0", fontSize: "16px", color: "#30353C" }}>
          <strong>
            Je me branche sur ce que vous avez déjà
          </strong>
          {" : Shopify, PrestaShop, WooCommerce, Amazon, votre ERP (Odoo, Sage, Cegid…), votre caisse et vos Excel. Rien n'est à remplacer."}
        </p>
      </div>
    </section>
  );
}
